const applicationValidChangeStatus = (state) => (currentStatus) => {
  return state.applicantValidStatusToChangeTo[currentStatus];
};

export default {
  applicationValidChangeStatus: applicationValidChangeStatus,
};
